/**
 * Homepage review copy + schema helpers.
 * Google aggregate on #business; featured quotes are Tripadvisor (not reused as Google reviews).
 */

export const HOME_GOOGLE_AGGREGATE_RATING = {
  "@type": "AggregateRating",
  ratingValue: "4.9",
  reviewCount: "511",
  bestRating: "5",
  worstRating: "1",
};

/** Shown on page + JSON-LD Review on LocalBusiness @id #business */
export const HOME_FEATURED_TRIPADVISOR_REVIEWS = [
  {
    author: "Samira J",
    rating: "5",
    body:
      "All in all a 10/10 experience. Rafik captained our boat (Nemo) magnificently — we even saw several dolphins. We highly recommend India Boats.",
  },
  {
    author: "Ankit",
    rating: "5",
    body:
      "I booked the premium yacht for 3 people and the process was seamless — they delivered what was promised. Particular about safety, which matters. Would definitely book again.",
  },
  {
    author: "Cecilia M",
    rating: "5",
    body:
      "A great sunset boat ride led by Rafik. Very scenic — we played our own music and they gave us chai. A friendly team.",
  },
  {
    author: "Hetvi D",
    rating: "5",
    body:
      "We went sailing on NEMO with 4–5 senior citizens — outstanding experience, very clean, and the crew handled everyone brilliantly.",
  },
];

export const buildHomeLocalBusinessReviewsSchema = () =>
  HOME_FEATURED_TRIPADVISOR_REVIEWS.map((item) => ({
    "@type": "Review",
    author: { "@type": "Person", name: item.author },
    reviewRating: { "@type": "Rating", ratingValue: item.rating },
    reviewBody: item.body,
    publisher: { "@type": "Organization", name: "Tripadvisor" },
  }));
